<div class="page-container" style="min-height:188.38330078125px">
  <div class="page-content text-center">
    <div class="panel panel-flat">
      <div class="panel-body">

        <!--
          Consent banner for the bundle. Shown if ANY job in it requires disclosure;
          one acceptance fans out server-side to one row per job. Decline is a separate navbar
          action and is never gated, so a signer who refuses still has a way out.
        -->
        @if (disclosureGateOpen && disclosure) {
          <div class="multisign-disclosure-gate text-left">
            <app-disclosure-consent
              [consentText]="disclosure.consentText"
              [disclosureTitle]="'Electronic Record and Signature Disclosure' | translate"
              [submitting]="disclosureSubmitting"
              (openRequested)="openDisclosureModal()"
              (accepted)="acceptDisclosure()">
            </app-disclosure-consent>
          </div>
        }

        <app-disclosure-modal
          [visible]="disclosureModalVisible"
          [title]="'Electronic Record and Signature Disclosure' | translate"
          [body]="disclosure?.body"
          [loading]="disclosureLoading"
          (closed)="closeDisclosureModal()">
        </app-disclosure-modal>

        <div class="row">
          <h2 style="margin-top: 0; padding: 10px;  background-color: #f9f9f9" translate>Document List to Sign</h2>
          <div class="table-responsive">
            <table class="table table-striped table-condensed table-hover">
              <thead>
                <tr style="font-size: large; font-weight: bold">
                  <th class="col-sm-1 col-xs-2 text-center" translate>Actions</th>
                  <th class="col-sm-5 col-xs-4 text-left" translate>Name</th>
                  <th class="col-sm-1 col-xs-1 text-center" translate>Page</th>
                  <th class="col-sm-1 col-xs-1 text-center" translate>Size</th>
                  <th class="col-sm-2 col-xs-2 text-center" translate>Creation</th>
                  <th class="col-sm-2 col-xs-2 text-center" translate>Request Time</th>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of multiRequestResults; let i=index">
                <td class="col-sm-1 col-xs-2 text-center ms-actions">
                  <button type="button" class="btn btn-link btn-sm ms-action ms-view" *ngIf="isPAdES(item?.signature)"
                          (click)="viewDocument(item)" title="{{ 'View' | translate }}">
                    <i class="icon-eye"></i>
                  </button>
                  <button type="button" class="btn btn-link btn-sm ms-action ms-download" *ngIf="isCAdES(item?.signature)"
                          (click)="downloadDocument(item)" title="{{ 'Download' | translate }}">
                    <i class="icon-download"></i>
                  </button>
                  <button type="button" class="btn btn-link btn-sm ms-action ms-info" *ngIf="canShowInfo(item)"
                          (click)="openInfo(item)" title="{{ 'Info' | translate }}">
                    <i class="icon-info3"></i>
                  </button>
                </td>
                <td class="col-sm-5 col-xs-4 text-left" style="font-size: larger">{{item?.jobName}}</td>
                <td class="col-sm-1 col-xs-1">{{item?.page}}</td>
                <td class="col-sm-1 col-xs-1">{{item?.size}}</td>
                <td class="col-sm-2 col-xs-2">{{item?.created |  date: 'dd/MM/yyyy'}}</td>
                <td class="col-sm-2 col-xs-2">{{item?.startTime | date: 'dd/MM/yyyy'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PDF preview modal (view action, PADES rows) with rotate / zoom / page controls -->
  <div class="modal fade" id="multiSignViewModal" tabindex="-1" role="dialog" *ngIf="viewModalVisible">
    <div class="modal-dialog ms-view-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeViewModal()">&times;</button>
          <h5 class="modal-title text-left">{{ viewingName }}</h5>
        </div>
        <div class="ms-view-toolbar text-center">
          <button type="button" class="btn btn-default btn-sm" (click)="prevPage()" [disabled]="viewPage <= 1"
                  title="{{ 'Previous' | translate }}"><i class="icon-arrow-left15"></i></button>
          <span class="ms-page-indicator">{{ viewPage }} / {{ viewTotalPages }}</span>
          <button type="button" class="btn btn-default btn-sm" (click)="nextPage()" [disabled]="viewPage >= viewTotalPages"
                  title="{{ 'Next' | translate }}"><i class="icon-arrow-right15"></i></button>
          <span class="ms-toolbar-sep"></span>
          <button type="button" class="btn btn-default btn-sm" (click)="zoomOut()"
                  title="{{ 'Zoom Out' | translate }}"><i class="icon-zoomout3"></i></button>
          <button type="button" class="btn btn-default btn-sm" (click)="zoomIn()"
                  title="{{ 'Zoom In' | translate }}"><i class="icon-zoomin3"></i></button>
          <span class="ms-toolbar-sep"></span>
          <button type="button" class="btn btn-default btn-sm" (click)="rotateView()"
                  title="{{ 'Rotate' | translate }}"><i class="icon-rotate-cw"></i></button>
        </div>
        <div class="modal-body ms-view-body">
          <pdf-viewer *ngIf="viewPdfSrc" [src]="viewPdfSrc" [page]="viewPage" [rotation]="viewRotation"
                      [zoom]="viewZoom" [show-all]="false" [render-text]="false" [original-size]="false"
                      (after-load-complete)="onPdfLoad($event)"
                      style="display:block; width:100%; height:75vh;">
          </pdf-viewer>
        </div>
      </div>
    </div>
  </div>
</div>
